import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import { reportWebVitals } from './lib/webVitals';
import './lib/i18n';
import './index.css';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    if (event.user) {
      delete event.user.email;
      delete event.user.username;
    }
    return event;
  },
});

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Sentry.ErrorBoundary
    fallback={({ error, resetError }) => (
      <div className="min-h-screen flex items-center justify-center p-8">
        <div className="text-center max-w-md">
          <h2 className="text-xl font-semibold mb-2">Something went wrong</h2>
          <p className="text-muted-foreground text-sm mb-4">
            We've been notified and are looking into it.
          </p>
          <p className="text-xs text-muted-foreground font-mono mb-4">
            {String(error).slice(0, 120)}
          </p>
          <div className="flex gap-2 justify-center">
            <button
              onClick={resetError}
              className="px-4 py-2 bg-blue-600 text-white rounded text-sm"
            >
              Try Again
            </button>
            <a href="/" className="px-4 py-2 border rounded text-sm">
              Go Home
            </a>
          </div>
        </div>
      </div>
    )}
  >
    <App />
  </Sentry.ErrorBoundary>,
);

reportWebVitals();
